import { render } from "./PriceTag.vue?vue&type=template&id=751c5380&scoped=true"
import script from "./PriceTag.vue?vue&type=script&lang=js"
export * from "./PriceTag.vue?vue&type=script&lang=js"

import "./PriceTag.vue?vue&type=style&index=0&id=751c5380&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751c5380"]])

export default __exports__